export enum OrderLineItemTypeEnum {
    CHILD_PRODUCT = 14,
    DONATION_PRODUCT = 15
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/order-lineitem-type.enum.ts